import { ListAllResponse, VacationRpc } from "rpc/VacationRpc";
import { AData } from "./AData";

export class VacationData extends AData<ListAllResponse> {

    private data: ListAllResponse = null;

    private readonly maxAge: number;
    public readonly year;
    private lastUpdate: number = 0;

    public constructor(year: number, maxAge: number) {
        super();
        this.year = year;
        this.maxAge = maxAge;
    }

    protected doLoad(): Promise<ListAllResponse> {
        return VacationRpc.listAll(this.year)
            .then((res) => {
                this.lastUpdate = Date.now();
                return res;
            });
    }

    protected getCached(): ListAllResponse {
        if (this.maxAge > 0) {
            if (this.lastUpdate < Date.now() - this.maxAge) {
                this.data = null;
            }
        }

        return this.data;
    }

    protected storeCached(data: ListAllResponse) {
        this.data = data;
    }

}